import { Pipe, PipeTransform } from '@angular/core';
import { LoginService } from '../../../services/login/login.service';

@Pipe({
  name: 'permiso'
})
export class PermisoPipe implements PipeTransform {

  constructor(
    private login?: LoginService
  ) { }
  transform(permiso: any, user?: any, opc?: any): any {
    
    if (this.login.isLoggedClientePedido()) {
      const dataUser = this.login.getDataClientePedido();
      switch (permiso) {
        case 'precio':
          return dataUser.allow_prices === 'SI';
        case 'estado-cuenta':
          return dataUser.permiso_estado_cuenta === 'SI';
        case 'carrito':
          return dataUser.permiso_carrito_compras === 'SI';
        case 'compras':
          return dataUser.permiso_comprar === 'SI';
        case 'pedidos':
          return dataUser.permiso_comprar === 'SI';
        case 'historial':
          return dataUser.permiso_carrito_compras === 'SI';
        case 'facturacion':
          return dataUser.permiso_facturacion === 'SI';
        case 'usuarios':
          return dataUser.permiso_agregar_clientes_finales === 'SI';
        case 'usuarios-main':
          return user.es_cliente_final === 'SI';
        case 'usuarios-login': // este devolvera verdaredo si el usuario es el mismo del que se logueo
          return dataUser.email === user.email;
        case 'login': // este devolvera verdaredo si el usuario es el mismo del que se logueo
          return this.login.isLogged();
        case 'loginCliente':
          return this.login.isLoggedClientePedido();
        case 'no-publico-general': // este devolvera verdaredo si el usuario es el mismo del que se logueo
          //console.log(dataUser.es_publicogeneral === 'NO')
          return (dataUser.es_publicogeneral === 'NO');
        case 'cuenta-vinculada': // este devolvera verdaredo si el usuario es el mismo del que se logueo
          return dataUser.uid !== '';
        case 'publico-general': // este devolvera verdaredo si el usuario es el mismo del que se logueo
          return dataUser.es_publicogeneral === 'SI';
        case 'documentacion':
          return dataUser.permiso_documentacion === true;
        case 'permiso_kabiCoins': // se controla en el login_kb, modificarlo a false para que los vendedores no puedan canjear puntos kabiCoins
          return dataUser.permiso_kabiCoins;
        default:
          break;
      }
    } else {
      switch (permiso) {
        case 'precio':
          return true;
        case 'login':
          return this.login.isLoggedClientePedido();
      }
    }
    return false;
  }
}
